module.exports = __webpack_public_path__ + "img/big_logo.4864206c.png";